import React, { PureComponent } from 'react';
import { withRouter } from 'react-router';
import { withTranslation } from 'react-i18next';

import { getStatus } from '../api/global-api';

import niftyLogo from '../images/nifty-logo.svg';

const STATUS_CHECK_INTERVAL = 1000 * 60 * .5; // 30 secs

class Maintenance extends PureComponent {
    getContent() {
        const { t } = this.props;
        const locationState = this.props.location.state;
        let code;

        code = locationState && locationState.code;

        switch (code) {
            case 440:
                return <p>{ t('scheduledMaintenance') }</p>;

            case 520:
                return <p>{ t('updateRequired') }</p>;

            default:
                return <p>{ t('maintenance') }</p>;
        }
    }

    hasAccessRequest(token, teamUrl) {
        getStatus()
            .then(response => {
                this.props.history.push({
                    pathname: `/dashboard`
                });
            });
    }

    componentDidMount() {
        this.hasAccessRequest();
        this.interval = setInterval(() => {
            this.hasAccessRequest();
        }, STATUS_CHECK_INTERVAL);
    }

    componentWillUnmount() {
        clearInterval(this.interval);
    }

    render() {
        const { t } = this.props;

        return (
            <div className="maintenance">
                <div className="maintenance-inner">
                    <img className="logo" src={niftyLogo} width="150px" alt={ t('common:Nifty logo') } />

                    { this.getContent() }

                    <p>-{ t('common:The Nifty Team') }</p>
                </div>
            </div>
        );
    }
};

export default withRouter(withTranslation(['errors', 'common'])(Maintenance));
